import { DECORATIVE_CONTEXTS } from './questionTypeLabels'

const appendPins = (formData, markBase, pins) => {
  pins.forEach((pin, index) => {
    const pinBase = `${markBase}[mark_pins_attributes][${index}]`
    if (pin.id)
      formData.append(`${pinBase}[id]`, pin.id)
    if (pin.markedForDestroy) {
      formData.append(`${pinBase}[_destroy]`, '1')
      return
    }
    formData.append(`${pinBase}[pos_x]`, pin.pos_x)
    formData.append(`${pinBase}[pos_y]`, pin.pos_y)
    formData.append(`${pinBase}[position]`, pin.position ?? 0)
  })
}

const appendValueByContext = (formData, markBase, mark) => {
  const { context } = mark.question
  if (context === 'grade' || context === 'selection') {
    if (mark.new_option_content)
      formData.append(`${markBase}[new_option_content]`, mark.new_option_content)
    else
      formData.append(`${markBase}[option_id]`, mark.option_id ?? '')
  } else if (context === 'selection_multi') {
    if (mark.option_ids.length === 0)
      formData.append(`${markBase}[option_ids][]`, '')
    mark.option_ids.forEach(id => formData.append(`${markBase}[option_ids][]`, id))
  } else if (context === 'datetime')
    formData.append(`${markBase}[datetime_value]`, mark.datetime_value ?? '')
  else if (context === 'signature') {
    formData.append(`${markBase}[value]`, mark.value ?? '')
    if (mark.signatureData === null)
      formData.append(`${markBase}[signature][data]`, '')
    else if (mark.signatureData)
      formData.append(`${markBase}[signature][data]`, mark.signatureData)
  } else if (context === 'plan')
    appendPins(formData, markBase, mark.mark_pins_attributes || [])
  else
    formData.append(`${markBase}[value]`, mark.value ?? '')
}

const buildMarksFormData = (formData, base, marks) => {
  marks
    .filter(mark => !DECORATIVE_CONTEXTS.includes(mark.question.context))
    .forEach((mark, index) => {
      const markBase = `${base}[marks_attributes][${index}]`
      formData.append(`${markBase}[id]`, mark.id)
      formData.append(`${markBase}[default]`, 'false')
      appendValueByContext(formData, markBase, mark)
    })
  return formData
}

export default buildMarksFormData
